// extracted by mini-css-extract-plugin
export default {"Container":"ResultBalls_Container__OaCbA","Ball":"ResultBalls_Ball__xvWjL","Normal":"ResultBalls_Normal__Rb74q","Bonus":"ResultBalls_Bonus__Crep+","Text":"ResultBalls_Text__YQs1r"};